const setStorageSupplier = (rows) => {
    const obj = {
        "sd_selectedOption": 1,
        "sd_supplier": {
            "id":               rows[0].supplier.id,
            "Title":            rows[0].supplier.Title,
            "BillAddress":      rows[0].supplier.BillAddress,
            "cityName":         rows[0].supplier.city?.name ?? '',
            "stateName":        rows[0].supplier?.state?.statesCode ?? '',
            "countryName":      rows[0].supplier?.country?.name ?? '',
            "PostalZipCode":    rows[0].supplier.PostalZipCode,
        },
        "sd_packer":                    {id : null },
        "sd_broker":                    {id : null },
        "sd_ship":                      null,
        "sd_formatteDate":              null,
        "sd_payment_term":              {"id": rows[0].payment_id, "value": rows[0].payment_value },
        "sd_incoterm":                  {"id": rows[0].productincoterm_id, "value": rows[0].productincoterm_value },
        "sd_incoterm_2":                {"id": rows[1]?.productincoterm_id ?? null, "value": rows[1]?.productincoterm_value ?? null },
        "sd_incoterm_3":                {"id": rows[2]?.productincoterm_id ?? null, "value": rows[2]?.productincoterm_id ?? null },
        "sd_incoterm_4":                {"id": rows[3]?.productincoterm_id ?? null, "value": rows[3]?.productincoterm_id ?? null },
        "sd_finalDestination":          null,
        "sd_specialDiscount":           null,
        "sd_end_date":                  null,
        "sd_label":                     null,
        "sd_finalDest":                 null,
        "sd_additionalShipmentDetail":  rows[0].shipping,
        "sd_commision":                 null,
        "sd_ship_address":              null,
        "sd_ship_address_2":            null,               
        "sd_ship_address_3":            null,
        "sd_ship_address_4":            null,
        "sd_supplier_condition" :       {id : null },
        "label_description" :           null,
    }
    localStorage.setItem('DataSupplierDetail', JSON.stringify(obj)); 
}

const setStorageContractMaster = ( rows ) => {
    const country = { id: rows[0].country.id , name: rows[0].country.name, Code: rows[0].country.Code}
    const category = { id : rows[0]?.category?.id ?? null, name: rows[0]?.category?.name ?? null, code:rows[0]?.category?.code ?? null }
    localStorage.setItem('countrySelected', JSON.stringify(country));
    localStorage.setItem('categorySelected', JSON.stringify(category));
    localStorage.setItem('is_from_cost', true);
}

const setStorageProducts = async ( rows,  get_data_customTable) => {
    let itemList = [];
    const data = await get_data_customTable('items');
    itemList = data;

    let productArray = [];
    let index = 1;
    for (const item of rows) {
        let obj = {
            pd_unique_id : "" + item.product.id + index,
            pd_contrac_product_id: null,
            pd_country_destination: { id: null }, 
            pd_crop: { id: item.product_crop_id, value: item.product_crop_value },
            pd_item: itemList[index - 1], // <- pendiente
            pd_subCategory: {
                id: item.product_subcategory_id,
                value: item.product_subcategory_value,
            },
            pd_product: {
                id: item.product.id,
                name: item.product.name,
                category: null,
            },
            pd_variety : null,
            pd_feature: {
                id: item.product_feature_id,
                value: item.product_feature_value,
            },
            pd_cut_size: {
                id: item.product_cutsize_id,
                value: item.product_cutsize_value,
            },
            pd_grade: { id: item.product_grade_id, value: item.product_grade_value },
            pd_typedata: {
                id: item.product_org_conv_id,
                value: item.product_org_conv_value,
            },
            pd_quantity: item.productpack_quantity ? Number(item.productpack_quantity) : 0,
            pd_pack: { id: item.productpack_pack_id, value: item.productpack_pack_value },
            pd_weight: item.productsize_quantity ? Number(item.productsize_quantity) : 0,
            pd_net: { id: item.productsize_size_id, code: item.productsize_size_code }, // <- Confirmar creo tiene diferentes fuentes
            pd_supplierCurrency: {
                id: item.price_currency_id ?? null,
                Code: item.price_currency_code ?? null,
            },
            pd_suplierPrice: item.price_value ? Number(item.price_value) : null,
            pd_supplierUnit: {
                id: item.price_unit_id,
                code: item.price_unit_code,
            },
            pd_customerCurrency: {
                id: item.priceterms_currency_id ?? null,
                Code: item.priceterms_currency_code ?? null,
            },
            pd_customerPrice: item.priceterms_value ? Number(item.priceterms_value) : 0,
            pd_customerUnit: {
                id: item.priceterms_unit_id,
                code: item.priceterms_unit_code,
            },
            pd_tariff: null,
            pd_duty: null,
            pd_hts_code : null,
            pd_loads: 0,
            pd_note: null,
            pd_quantity_detail: null,
            supplier_price_detail : null,
            supplier_qty_detail : null,
            customer_price_detail : null,
            customer_qty_detail : null,
            supplier_additional_fees : null,
            supplier_additional_fees_comment: null,
            customer_additional_fees : null,
            customer_additional_fees_comment : null,
        };
        productArray.push(obj);
        index ++;
    }
    await localStorage.setItem("selectedProducts", JSON.stringify(productArray));
}

const setStorageCustomer = ( rows ) => {
    const obj = {
        "cud_selectedOption": 1,
        "cud_customer": {
            "id":           rows[0].customer.id,
            "Title":        rows[0].customer.Title,
            "BillAddress":  rows[0].customer.BillAddress,
            "cityName":     rows[0].customer.city.name,
            "stateName":    rows[0].customer.state.name,
            "countryName":  rows[0].customer.country.name,
            "PostalZipCode" : rows[0].customer.PostalZipCode,
        },
        "cud_selected_ship_address_1": null,
        "cud_selected_ship_address_2": null,
        "cud_selected_ship_address_3": null,
        "cud_selected_ship_address_4": null,
        "cud_ship": null,
        "cud_incoterm": {
            "id":     rows[0].customer_incoterm_id,
            "value":  rows[0].customer_incoterm_value,
        },
        "cud_incoterm_2": {
            "id":     rows[1]?.customer_incoterm_id ?? null,
            "value":  rows[1]?.customer_incoterm_value ?? null,
        },
        "cud_incoterm_3": {
            "id":     rows[2]?.customer_incoterm_id ?? null,
            "value":  rows[2]?.customer_incoterm_value ?? null,
        },
        "cud_incoterm_4": {
            "id":     rows[3]?.customer_incoterm_id ?? null,
            "value":  rows[3]?.customer_incoterm_value ?? null,
        },
        "cud_pay_term": null,
        "cud_end_date": null,
        "cud_customer_cond": null,
        "cud_broker": { id:null },
        "cud_finalDest" : null,
        "cud_finalDestination" :  null,
        "cud_label": null,
        "cud_start_date": null,
        "cud_additional_ship": null,
        "cud_commision": null,
        "cud_master_po": null,
        "cud_customer_condition" : { id:null },
        "label_description" : null,
    }
    localStorage.setItem('DataCustomerDetail', JSON.stringify(obj));
}

const setStorageContract = async ( rows ) => {
    const ids = rows.map(row => row.id);

    const  obj = {
        "cd_contract_id"                : null,
        "status"                        : null,
        "fiscal_year"                   : null,
        "load_type"                     : null,
        "product_type"                  : { id : null },
        "salesCoord"                    : { id : null },
        "logisticCoord"                 : { id : null },
        "shipment_type"                 : null,
        "loads"                         : null,
        "loads_completed"               : null,
        "tem_celsius"                   : null,
        "load_method"                   : null,
        "approve_contract"              : null,
        "checkbox"                      : [],
        "additional_info"               : null,
        "from_costing"                  : ids,
    }
    localStorage.setItem('DataContractDetail', JSON.stringify(obj)); 
}

export const setStorage = async ( rows, get_data_customTable ) => {
    console.log(rows);
    await setStorageContractMaster ( rows );
    await setStorageContract( rows );
    await setStorageProducts( rows, get_data_customTable );
    await setStorageSupplier( rows );
    await setStorageCustomer( rows );           
}

export const clearStorage = () => {
    localStorage.removeItem("DataContractDetail");
    localStorage.removeItem("DataContractMaster");
    localStorage.removeItem("DataProductDetail");
    localStorage.removeItem("DataSupplierDetail");
    localStorage.removeItem("DataCustomerDetail");
    localStorage.removeItem("categorySelected");
    localStorage.removeItem("contractNumber");
    localStorage.removeItem("countrySelected");
    localStorage.removeItem("selectedProducts");
    localStorage.removeItem("process_add_contract");

    localStorage.removeItem('DataContractDetail_edit');
    localStorage.removeItem('DataProductDetail_edit');
    localStorage.removeItem('selectedProducts_edit');
    localStorage.removeItem('DataSupplierDetail_edit');
    localStorage.removeItem('DataCustomerDetail_edit');
    localStorage.removeItem('DataRevision_edit');

    localStorage.removeItem('DataContractDetail_view');
    localStorage.removeItem('DataProductDetail_view');
    localStorage.removeItem('selectedProducts_view');
    localStorage.removeItem('DataSupplierDetail_view');
    localStorage.removeItem('DataCustomerDetail_view');
    localStorage.removeItem('DataRevision_view');

    localStorage.removeItem("DataContractDetail");
    localStorage.removeItem("DataProductDetail");
    localStorage.removeItem("DataSupplierDetail");
    localStorage.removeItem("DataCustomerDetail");
    localStorage.removeItem("selectedProducts");

    localStorage.removeItem('process_view_contract');
    localStorage.removeItem('process_edit_contract');
    localStorage.removeItem('process_add_contract');
}